export function wasBackgroundBannerNotSeen({ banners }) {
    return banners.backgroundEffects?.steps.length > 0;
}
